import React, { useState } from 'react';
import axios from 'axios';
import styles from './BrowseFileUpdate.module.css';
import { style } from './style';

const BrowseFileUpdate = ({ onImageUpload }) => {
    const [imageFile, setImageFile] = useState(null);
    const [imagePreview, setImagePreview] = useState("");

    const handleImageChange = (e) => {
        const file = e.target.files[0];
        setImageFile(file);
        setImagePreview(URL.createObjectURL(file));
    };

    const submitImage = () => {
        if (!imageFile) return;
        
        const data = new FormData();
        data.append("file", imageFile);
        data.append("cloud_name", "boho-pf");
        data.append("upload_preset", "boho_events");

        axios.post('https://api.cloudinary.com/v1_1/boho-pf/image/upload', data)
            .then((res) => {
                console.log(res.data);
                setImagePreview(res.data.secure_url);
                if (onImageUpload) {
                    onImageUpload(res.data.secure_url);
                }
            })
            .catch((err) => {
                console.log(err.response ? err.response.data : err);
            });
    };

    const removeImage = () => {
        setImageFile(null);
        setImagePreview("");
        onImageUpload("");
    };

    return (
        <div className={styles.containerCloud}>
            {/* <label className={styles.customFileUpload} htmlFor="file">
                <div className={styles.icon}>
                    <input type="file" id="file" onChange={handleImageChange} />
                    <svg xmlns="http://www.w3.org/2000/svg" fill="" viewBox="0 0 24 24">
                        <g strokeWidth="0" id="SVGRepo_bgCarrier"></g>
                        <g strokeLinejoin="round" strokeLinecap="round" id="SVGRepo_tracerCarrier"></g>
                        <g id="SVGRepo_iconCarrier">
                            <path fill="" d="M10 1C9.73478 1 9.48043 1.10536 9.29289 1.29289L3.29289 7.29289C3.10536 7.48043 3 7.73478 3 8V20C3 21.6569 4.34315 23 6 23H7C7.55228 23 8 22.5523 8 22C8 21.4477 7.55228 21 7 21H6C5.44772 21 5 20.5523 5 20V9H10C10.5523 9 11 8.55228 11 8V3H18C18.5523 3 19 3.44772 19 4V9C19 9.55228 19.4477 10 20 10C20.5523 10 21 9.55228 21 9V4C21 2.34315 19.6569 1 18 1H10ZM9 7H6.41421L9 4.41421V7ZM14 15.5C14 14.1193 15.1193 13 16.5 13C17.8807 13 19 14.1193 19 15.5V16V17H20C21.1046 17 22 17.8954 22 19C22 20.1046 21.1046 21 20 21H13C11.8954 21 11 20.1046 11 19C11 17.8954 11.8954 17 13 17H14V16V15.5ZM16.5 11C14.142 11 12.2076 12.8136 12.0156 15.122C10.2825 15.5606 9 17.1305 9 19C9 21.2091 10.7909 23 13 23H20C22.2091 23 24 21.2091 24 19C24 17.1305 22.7175 15.5606 20.9844 15.122C20.7924 12.8136 18.858 11 16.5 11Z" clipRule="evenodd" fillRule="evenodd" />
                        </g>
                    </svg>
                </div>
                <div className={styles.text}>
                    <span>Click para subir imagen</span>
                </div>
                {imagePreview && <img src={imagePreview} className={styles.imageUrl} alt="Uploaded preview" />}

            </label>
            <div className={styles.buttonContainerUpdate}>
                <button type="button" className={style.button} onClick={removeImage}>Eliminar</button>
                <button type="button" className={style.button} onClick={submitImage}>Confirmar</button>
            </div> */}
            <div>
                <div className={style.container}>
                    <label for="dropzone-file" className={style.cube}>
                        <div className="flex flex-col items-center justify-center pt-5 pb-6">
                            <svg className="w-8 h-8 mb-4 text-gray-500 dark:text-gray-400" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 16">
                                <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 13h3a3 3 0 0 0 0-6h-.025A5.56 5.56 0 0 0 16 6.5 5.5 5.5 0 0 0 5.207 5.021C5.137 5.017 5.071 5 5 5a4 4 0 0 0 0 8h2.167M10 15V6m0 0L8 8m2-2 2 2" />
                            </svg>
                            <p className="mb-2 text-sm text-gray-500 dark:text-gray-400"><span className="font-semibold">Click to upload</span> or drag and drop</p>
                            <p className="text-xs text-gray-500 dark:text-gray-400">SVG, PNG, JPG or GIF.</p>
                        </div>
                        <input id="dropzone-file" type="file" className="hidden" onChange={handleImageChange}/>
                        {imagePreview && <img src={imagePreview} className={style.img} alt="Uploaded preview" />}
                    </label>
                </div>
                <div className={styles.buttonContainerUpdate}>
                    <button type="button" className={style.button} onClick={removeImage}>Eliminar</button>
                    <button type="button" className={style.button} onClick={submitImage}>Confirmar</button>
                </div>
            </div>
        </div>
    );
};

export default BrowseFileUpdate;